<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <!-- <el-card style="max-height:340px">
              <Leftbar></Leftbar>
            </el-card> -->
            <el-card class="rightContent">
              <h3>
                {{ $t("profile.editProfileL") }}
                <span style="float: right">
                  <el-button
                    type="primary"
                    @click="submitForm('personInfoEditForm')"
                    >{{ $t("button.save") }}
                  </el-button>
                  <el-button type="primary" @click="goBack"
                    >{{ $t("button.cancel") }}
                  </el-button>
                  <!-- <el-button @click="resetForm('personInfoEditForm')">重置</el-button> -->
                </span>
              </h3>
              <el-divider></el-divider>
              <el-form
                :model="personInfoEditForm"
                :rules="rules"
                ref="personInfoEditForm"
                label-width="140px"
                class="demo-personInfoEditForm"
              >
                <el-form-item :label="$t('profile.name')" prop="name">
                  <el-input
                    v-model="personInfoEditForm.name"
                    style="width: 300px"
                  ></el-input>
                  <span class="input_notice">{{
                    $t("profile.competitionInfoTip")
                  }}</span>
                </el-form-item>
                <el-form-item :label="$t('profile.identity')" prop="identity">
                  {{
                    personInfoEditForm.identity == 3
                      ? $t("profile.student")
                      : $t("profile.teacher")
                  }}
                </el-form-item>
                <el-form-item :label="$t('profile.tel')" prop="mobile">
                  <el-input
                    v-model="personInfoEditForm.mobile"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item
                  v-if="personInfoEditForm.identity == 3"
                  :label="$t('profile.stuNumber')"
                  prop="studentNumber"
                >
                  <el-input
                    v-model="personInfoEditForm.studentNumber"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('profile.email')" prop="email">
                  <el-input
                    v-model="personInfoEditForm.email"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('profile.school')" prop="school">
                  <el-input
                    v-model="personInfoEditForm.school"
                    style="width: 300px"
                  ></el-input>
                  <span class="input_notice">{{
                    $t("profile.competitionInfoTip")
                  }}</span>
                </el-form-item>
                <el-form-item :label="$t('profile.location')" prop="province">
                  <el-select
                    v-model="personInfoEditForm.province"
                    style="width: 300px"
                  >
                    <el-option
                      v-for="item in provinceData"
                      :key="item.value"
                      :label="
                        $i18n.locale === 'en' ? item.label_en : item.label_cn
                      "
                      :value="item.label_cn"
                    ></el-option>
                  </el-select>
                  <span class="input_notice">{{
                    $t("profile.competitionInfoTip")
                  }}</span>
                </el-form-item>
                <el-form-item
                  :label="$t('profile.mentor_email')"
                  prop="teacher_email"
                  v-if="personInfoEditForm.identity === 3"
                >
                  <el-input
                    v-model="personInfoEditForm.teacher_email"
                    style="width: 300px"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$t('profile.attachment')" prop="file">
                  <el-upload
                    class="upload-demo"
                    action=""
                    ref="profileFileUploader"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    multiple
                    :auto-upload="false"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                  >
                    <el-button size="small" type="primary">
                      {{ $t("button.upload") }}
                    </el-button>
                    <div slot="tip" class="el-upload__tip">
                      {{ $t("profile.uploadLimit") }}
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item :label="$t('profile.password')" prop="teacher">
                  <el-button type="danger" @click="changePwd">
                    {{ $t("profile.editPassword") }}
                  </el-button>
                </el-form-item>
              </el-form>
            </el-card>
          </div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 优化点
import Leftbar from "../../components/newComponent/Leftbar";
import { userInfoGet, userInfoEdit } from "../../api/user";

import {
  taskTypeFilter,
  taskStateFilter,
  taskBadgeFilter,
} from "../../utils/filter";
import { location } from "/public/location.js";
export default {
  components: {
    Leftbar,
  },
  name: "profile",
  bodyClass: "index-page",
  props: {},
  filters: {
    taskTypeFilter,
    taskStateFilter,
    taskBadgeFilter,
  },
  data() {
    return {
      firstname: null,
      email: null,
      password: null,
      leafShow: false,
      taskKeyword: "",
      personInfoEditForm: {
        id: "",
        name: "",
        mobile: "",
        email: "",
        province: "",
        studentNumber: "",
        teacher_email: "",
        school: "",
        file: "",
      },
      fileList: [],
      provinceData: [],
    };
  },
  created() {
    this.provinceData = location.map((x, i) => {
      return {
        label_cn: x.label_cn,
        label_en: x.label_en,
        value: i,
      };
    });
  },
  mounted() {
    this.initUserInfo();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let file =
            this.$refs["profileFileUploader"].uploadFiles.length >= 1
              ? this.$refs["profileFileUploader"].uploadFiles.pop().raw
              : "";
          let formdata = new FormData();
          formdata.append("id", this.personInfoEditForm.id || "");
          formdata.append("name", this.personInfoEditForm.name || "");
          formdata.append("mobile", this.personInfoEditForm.mobile || "");
          formdata.append("email", this.personInfoEditForm.email || "");
          formdata.append("province", this.personInfoEditForm.province || "");
          formdata.append(
            "studentNumber",
            this.personInfoEditForm.studentNumber || "",
          );
          formdata.append(
            "teacher_email",
            this.personInfoEditForm.teacher_email || "",
          );
          formdata.append("file", file || "");
          formdata.append("school", this.personInfoEditForm.school || "");
          userInfoEdit(formdata).then(
            (res) => {
              this.$notify({
                type: "success",
                title: this.$t("common.success"),
                duration: 3000,
              });
              this.$router.push("/profile");
            },
            (err) => {
              this.$notify({
                type: "error",
                title: this.$t("common.fail"),
                message: err.response.data.message,
                duration: 3000,
              });
            },
          );
        } else {
          this.$notify({
            type: "warning",
            title: this.$t("common.error"),
            duration: 3000,
            message: this.$t("common.formatInfo"),
          });
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    changePwd() {
      this.$router.push("/profile/pwdChange");
    },
    initUserInfo() {
      userInfoGet(localStorage.getItem("uid")).then((res) => {
        this.personInfoEditForm = res;
      });
    },
    handleRemove(file, fileList) {},
    handlePreview(file) {},
    handleExceed(files, fileList) {
      let that = this;
      this.$message.warning(that.$t("profile.fileExceed"));
    },
    beforeRemove(file, fileList) {
      return this.$confirm(
        this.$t("profile.confirmRemove") + ` ${file.name}` + "？",
      );
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  // 当$i18n.locale为en时，provincedata显示英文，为cn时，显示中文
  watch: {
    "$i18n.locale": function (val) {
      if (val === "en") {
        this.provinceData = location.map((x, i) => {
          return {
            label: x.label_en,
            value: i,
          };
        });
      } else {
        this.provinceData = location.map((x, i) => {
          return {
            label: x.label_cn,
            value: i,
          };
        });
      }
    },
  },
  computed: {
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`,
      };
    },
    rules() {
      let that = this;
      return {
        name: [
          {
            required: true,
            trigger: "blur",
            message: that.$t("common.notNull"),
          },
          {
            min: 2,
            max: 16,
            trigger: "blur",
            message: that.$t("registerPage.nameLength", { s: 2, l: 16 }),
          },
        ],
        school: [
          {
            required: true,
            trigger: "change",
            message: that.$t("common.notNull"),
          },
        ],
        province: [
          {
            required: true,
            trigger: "change",
            message: that.$t("common.notNull"),
          },
        ],
        email: [
          {
            required: true,
            trigger: "change",
            message: that.$t("common.notNull"),
          },
          {
            type: "email",
            message: that.$t("common.emailFormat"),
            trigger: ["blur", "change"],
          },
        ],
        teacher_email: [
          {
            required: true,
            trigger: "change",
            message: that.$t("common.notNull"),
          },
          {
            type: "email",
            message: that.$t("common.emailFormat"),
            trigger: ["blur", "change"],
          },
        ],
      };
    },
  },
  beforeDestroy() {},
};
</script>
<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>
<style scoped>
.input_notice {
  margin-left: 2em;
  color: red;
}
.input_notice::before {
  content: "*";
}
</style>
